module.exports = __webpack_public_path__ + "img/Feature-3.39355aa.svg";